(() => {
  if (window.HallstattInteractionsLoaded) return;
  window.HallstattInteractionsLoaded = true;

  // Account / KwikPass login handler
  document.addEventListener('click', function (event) {
    const profileLink = event.target.closest('.header__utils-item--account a');

    if (!profileLink) return;

    if (typeof window.handleKpAndShopifyLogin !== 'function') return;

    event.preventDefault();
    window.handleKpAndShopifyLogin('/account');
  }, true);

  const selectors = {
    searchDrawer: "search-drawer",
    searchSummary: "search-drawer > details > summary.drawer__button",
    searchClose: "search-drawer .js-btn-close-drawer",
    productForm: 'product-form form[data-type="add-to-cart-form"]'
  };

  const fetchJson = async (url, options = {}, timeout = 12000) => {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(url, {
        ...options,
        signal: controller.signal
      });
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        const message = getResponseError(data) || response.statusText;
        throw new Error(message);
      }

      return data;
    } finally {
      window.clearTimeout(timer);
    }
  };

  const fetchText = async (url, options = {}, timeout = 12000) => {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(url, {
        ...options,
        signal: controller.signal
      });

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      return response.text();
    } finally {
      window.clearTimeout(timer);
    }
  };

  const getResponseError = response => {
    const error = response?.description || response?.message || response?.errors;
    if (Array.isArray(error)) return error.join(", ");
    if (error && typeof error === "object") return Object.values(error).flat().join(", ");
    return error || "";
  };

  const getFocusableSearchInput = searchDrawer =>
    searchDrawer.querySelector(".js-drawer-focus-element, input[type='search']");

  const setSearchExpanded = (searchDrawer, expanded) => {
    searchDrawer.querySelectorAll(".drawer__button, .js-btn-close-drawer").forEach(button => {
      button.classList.toggle("menu-is-open", expanded);
      button.setAttribute("aria-expanded", String(expanded));
    });
  };

  const closeHeaderDrawer = () => {
    const headerDrawerDetails = document.querySelector("header-drawer details");
    if (!headerDrawerDetails) return;

    headerDrawerDetails.classList.remove("menu-opening", "drawer-transitioning");
    headerDrawerDetails.removeAttribute("open");
    headerDrawerDetails.querySelectorAll(".drawer__button, .js-btn-close-drawer").forEach(button => {
      button.classList.remove("menu-is-open");
      button.setAttribute("aria-expanded", "false");
    });
  };

  const openSearchDrawer = searchDrawer => {
    const details = searchDrawer.querySelector("details");
    if (!details) return;

    closeHeaderDrawer();
    details.setAttribute("open", "");
    details.classList.add("menu-opening");
    details.classList.remove("drawer-transitioning");
    setSearchExpanded(searchDrawer, true);

    document.body.style.overflow = "hidden";
    document.body.classList.add("drawer--is-open");
    document.getElementById("header")?.classList.remove("menu-open");

    window.requestAnimationFrame(() => {
      getFocusableSearchInput(searchDrawer)?.focus({ preventScroll: true });
    });
  };

  const closeSearchDrawer = searchDrawer => {
    const details = searchDrawer.querySelector("details");
    if (!details) return;

    details.classList.remove("menu-opening", "drawer-transitioning");
    setSearchExpanded(searchDrawer, false);

    if (!document.querySelector("details.menu-opening")) {
      document.body.style.overflow = "";
      document.body.classList.remove("drawer--is-open");
    }

    window.setTimeout(() => {
      if (!details.classList.contains("menu-opening")) details.removeAttribute("open");
    }, 250);
  };

  document.addEventListener("click", event => {
    const closeButton = event.target.closest(selectors.searchClose);
    const summary = event.target.closest(selectors.searchSummary);
    const control = closeButton || summary;
    if (!control) return;

    const searchDrawer = control.closest(selectors.searchDrawer);
    const details = searchDrawer?.querySelector("details");
    if (!searchDrawer || !details) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (closeButton || details.classList.contains("menu-opening") || details.hasAttribute("open")) {
      closeSearchDrawer(searchDrawer);
    } else {
      openSearchDrawer(searchDrawer);
    }
  }, true);

  document.addEventListener("keydown", event => {
    if (event.key !== "Escape") return;

    const openSearchDrawerElement = document.querySelector("search-drawer details.menu-opening")?.closest("search-drawer");
    if (!openSearchDrawerElement) return;

    event.preventDefault();
    closeSearchDrawer(openSearchDrawerElement);
  });

  const getMobileMenuPanel = button => {
    const panelId = button.getAttribute("aria-controls");
    return panelId ? document.getElementById(panelId) : null;
  };

  const refreshOpenMenuParents = button => {
    let parentPanel = button.closest(".menu-accordion__panel");

    while (parentPanel) {
      const parentButton = document.querySelector(
        `.menu-accordion__button[aria-controls="${parentPanel.id}"]`
      );

      if (parentButton?.getAttribute("aria-expanded") === "true") {
        parentPanel.style.height = `${parentPanel.scrollHeight}px`;
      }

      parentPanel = parentPanel.parentElement?.closest(".menu-accordion__panel");
    }
  };

  const closeChildMenuPanels = panel => {
    panel.querySelectorAll(".menu-accordion__button[aria-expanded='true']").forEach(childButton => {
      childButton.setAttribute("aria-expanded", "false");
      const childPanel = getMobileMenuPanel(childButton);
      if (childPanel) {
        childPanel.style.height = "0px";
      }
    });
  };

  document.addEventListener("click", event => {
    const button = event.target.closest("header-drawer .menu-accordion__button");
    if (!button) return;

    const panel = getMobileMenuPanel(button);
    if (!panel) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const isExpanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", String(!isExpanded));

    if (isExpanded) {
      closeChildMenuPanels(panel);
      panel.style.height = "0px";
    } else {
      panel.style.height = "auto";
      const panelHeight = panel.scrollHeight;
      panel.style.height = `${panelHeight}px`;
    }

    refreshOpenMenuParents(button);
  }, true);

  const getProductFormElement = form => form.closest("product-form");

  const getSubmitButtons = (productForm, form) => {
    const buttons = new Set(productForm.querySelectorAll('[type="submit"][name="add"]'));

    if (form.id) {
      document.querySelectorAll('[type="submit"][name="add"][form]').forEach(button => {
        if (button.getAttribute("form") === form.id) buttons.add(button);
      });
    }

    return [...buttons];
  };

  const setProductFormLoading = (buttons, loading) => {
    buttons.forEach(button => {
      button.classList.toggle("loading", loading);
      button.classList.toggle("disabled", loading);
      button.classList.toggle("is--loading", loading);
      button.classList.toggle("add-to-cart--is-disabled", loading);
      button.setAttribute("aria-disabled", String(loading));
      if (loading) {
        button.dataset.hallstattWasDisabled = String(button.disabled);
        button.disabled = true;
      } else {
        if (button.dataset.hallstattWasDisabled !== "true") button.disabled = false;
        delete button.dataset.hallstattWasDisabled;
      }
      button.querySelectorAll(".loading__spinner").forEach(spinner => {
        spinner.classList.toggle("hidden", !loading);
      });
    });
  };

  const showProductFormError = (productForm, message) => {
    if (typeof productForm.handleErrorMessage === "function") {
      productForm.handleErrorMessage(message);
      return;
    }

    const wrapper = productForm.querySelector(".product-form__error-message-wrapper");
    const text = productForm.querySelector(".product-form__error-message");
    if (!wrapper || !text) return;

    text.textContent = message || "";
    wrapper.toggleAttribute("hidden", !message);
  };

  const validateProductForm = form => {
    const quantityInput = form.querySelector('[name="quantity"]');
    if (quantityInput && !quantityInput.value) {
      quantityInput.value = quantityInput.min || "1";
    }

    if (quantityInput && !quantityInput.checkValidity()) {
      quantityInput.reportValidity();
      return false;
    }

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput || variantInput.disabled || !variantInput.value) {
      return false;
    }

    return true;
  };

  const syncVariantSelection = productForm => {
    const productInfo = productForm.closest("product-info");
    productInfo?.querySelector("product-variant-selects")?.syncProductFormFromCurrentSelection?.();
  };

  const getSelectedSellingPlan = productForm => {
    const purchaseOptions = productForm.closest("product-info")?.querySelector("purchase-options");
    if (!purchaseOptions || purchaseOptions.isOneTimePurchase?.()) return "";

    const activeSellingPlan = purchaseOptions.querySelector(
      '[data-selling-plans-wrapper]:not(.is-hidden) .product__purchase-group-selects:not(.is-hidden) [name="selling_plan"]'
    );

    if (!activeSellingPlan?.value) {
      purchaseOptions.showError?.();
      return null;
    }

    return activeSellingPlan.value;
  };

  const buildProductFormData = (form, productForm) => {
    const formData = new FormData(form);
    formData.delete("selling_plan_group");
    formData.delete("selling_plan");

    const sellingPlan = getSelectedSellingPlan(productForm);
    if (sellingPlan === null) return null;
    if (sellingPlan) formData.append("selling_plan", sellingPlan);

    return formData;
  };

  const getCartUrl = () => window.routes?.cart_url || `${window.Shopify?.routes?.root || "/"}cart`;

  const getCartAjaxUrl = url => {
    if (!url) return `${window.Shopify?.routes?.root || "/"}cart.js`;
    return url.endsWith(".js") ? url : `${url}.js`;
  };

  const GIFT_BOX_VARIANT_ID = 53593878692133;
  let isRemovingLoneGiftBox = false;

  const getRenderedDrawerItemCount = () => {
    const cartDrawerBody = document.querySelector("#CartDrawer-Body");
    if (!cartDrawerBody) return null;

    return Array.from(cartDrawerBody.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + (Number(quantityInput.value) || 0), 0);
  };

  const syncCartCounters = (cartState, preferRenderedDrawer = true) => {
    const renderedItemCount = preferRenderedDrawer ? getRenderedDrawerItemCount() : null;
    const stateItemCount =
      cartState && typeof cartState.item_count === "number"
        ? Number(cartState.item_count)
        : 0;
    const itemCount = renderedItemCount !== null ? renderedItemCount : stateItemCount;

    document.querySelectorAll(".cart-drawer__title-counter").forEach(counter => {
      counter.textContent = itemCount;
    });

    document.querySelectorAll(".cart-count-badge").forEach(counter => {
      counter.textContent = itemCount > 99 ? "+" : itemCount === 0 ? "" : itemCount;
      counter.classList.toggle("hidden", itemCount === 0);
    });

    document.querySelectorAll("cart-drawer").forEach(drawer => {
      drawer.classList.toggle("is-empty", itemCount === 0);
    });

    return {
      ...(cartState || {}),
      item_count: itemCount
    };
  };

  const getCartState = () => fetchJson(getCartAjaxUrl(getCartUrl()), {
    headers: {
      Accept: "application/json"
    }
  }, 8000);

  const getCartSectionNames = () => ["cart-drawer"];

  const getPositiveInteger = (value, fallback = 1) => {
    const number = Number(value);
    return Number.isFinite(number) && number > 0 ? Math.floor(number) : fallback;
  };

  const getLineItemProperties = formData => {
    const properties = {};

    formData.forEach((value, key) => {
      const propertyMatch = key.match(/^properties\[(.+)\]$/);
      if (!propertyMatch || value === "") return;

      properties[propertyMatch[1]] = value;
    });

    return Object.keys(properties).length ? properties : null;
  };

  const buildMainCartItem = formData => {
    const id = getPositiveInteger(formData.get("id"), 0);
    if (!id) return null;

    const item = {
      id,
      quantity: getPositiveInteger(formData.get("quantity"), 1)
    };
    const sellingPlan = formData.get("selling_plan");
    const properties = getLineItemProperties(formData);

    if (sellingPlan) item.selling_plan = sellingPlan;
    if (properties) item.properties = properties;

    return item;
  };

  const buildAddToCartRequest = (formData, productForm) => {
    const giftBoxCheckbox = productForm.querySelector("[data-gift-box-checkbox][data-gift-box-variant-id]");
    const giftBoxVariantId = getPositiveInteger(giftBoxCheckbox?.dataset.giftBoxVariantId, 0);

    if (!giftBoxCheckbox?.checked || !giftBoxVariantId) {
      formData.append("sections", getCartSectionNames().join(","));
      formData.append("sections_url", getCartUrl());

      return {
        body: formData,
        headers: {},
        productVariantId: formData.get("id")
      };
    }

    const mainCartItem = buildMainCartItem(formData);
    if (!mainCartItem) return null;

    return {
      body: JSON.stringify({
        items: [
          mainCartItem,
          {
            id: giftBoxVariantId,
            quantity: getPositiveInteger(giftBoxCheckbox.dataset.giftBoxQuantity, 1)
          }
        ],
        sections: getCartSectionNames(),
        sections_url: getCartUrl()
      }),
      headers: {
        "Content-Type": "application/json"
      },
      productVariantId: formData.get("id")
    };
  };

  const setCartDrawerLoading = (removeButton, loading) => {
    const cartDrawerItems = removeButton.closest("cart-drawer-items");
    cartDrawerItems?.classList.toggle("is-loading", loading);
    removeButton.dataset.hallstattRemoving = String(loading);
    removeButton.setAttribute("aria-disabled", String(loading));
  };

  const showCartLineError = (removeButton, message) => {
    const errorMessage = message === "" ? "" : message || window.cartStrings?.error || "Cart item could not be removed.";
    const lineError =
      removeButton.closest(".cart-item")?.querySelector("[data-line-item-error]") ||
      document.querySelector(`[data-line-item-error][data-line="${removeButton.dataset.index}"]`);

    if (lineError) {
      lineError.textContent = errorMessage;
    }
  };

  const changeCartLine = async bodyData => {
    const response = await fetch(getCartAjaxUrl(window.routes?.cart_change_url || `${window.Shopify?.routes?.root || "/"}cart/change`), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(bodyData)
    });
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        ...(data || {}),
        errors: getResponseError(data) || response.statusText
      };
    }

    return data || {};
  };

  const isGiftBoxCartItem = item =>
    Number(item?.variant_id) === GIFT_BOX_VARIANT_ID ||
    Number(item?.id) === GIFT_BOX_VARIANT_ID;

  const getLoneGiftBoxItem = cartState => {
    const items = Array.isArray(cartState?.items) ? cartState.items : [];
    if (!items.length || !items.every(isGiftBoxCartItem)) return null;
    return items[0];
  };

  const removeLoneGiftBox = async cartState => {
    const giftBoxItem = getLoneGiftBoxItem(cartState);
    if (!giftBoxItem || isRemovingLoneGiftBox) return cartState;

    isRemovingLoneGiftBox = true;

    try {
      const cleanedState = await changeCartLine({
        id: giftBoxItem.key || giftBoxItem.id,
        quantity: 0,
        sections: getCartSectionNames(),
        sections_url: getCartUrl()
      });

      if (cleanedState?.errors) {
        console.error("Lone gift box could not be removed:", cleanedState.errors);
        return cartState;
      }

      return cleanedState || cartState;
    } catch (error) {
      console.error("Lone gift box could not be removed:", error);
      return cartState;
    } finally {
      isRemovingLoneGiftBox = false;
    }
  };

  const getSectionMarkup = async () => {
    const params = new URLSearchParams({
      sections: getCartSectionNames().join(",")
    });

    return fetchJson(`${getCartUrl()}?${params.toString()}`, {
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }, 8000);
  };

  const getCartDrawerSectionMarkup = async () => {
    const params = new URLSearchParams({
      section_id: "cart-drawer"
    });

    return fetchText(`${getCartUrl()}?${params.toString()}`, {
      headers: {
        Accept: "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    }, 8000);
  };

  const replaceFromSection = (html, targetSelector, sourceSelector = targetSelector) => {
    const target = document.querySelector(targetSelector);
    if (!target || !html) return false;

    const source = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(sourceSelector);

    if (!source) return false;

    target.innerHTML = source.innerHTML;
    return true;
  };

  const renderCart = async (cartDrawer, initialSections = null) => {
    let sections = initialSections;
    let drawerUpdated = sections?.["cart-drawer"]
      ? replaceFromSection(sections["cart-drawer"], "#CartDrawer-Body", "#CartDrawer-Body")
      : false;

    if (!drawerUpdated) {
      sections = await getSectionMarkup().catch(() => null);
      drawerUpdated = sections?.["cart-drawer"]
        ? replaceFromSection(sections["cart-drawer"], "#CartDrawer-Body", "#CartDrawer-Body")
        : false;
    }

    if (!drawerUpdated) {
      const fallbackDrawerSection = await getCartDrawerSectionMarkup().catch(() => null);
      drawerUpdated = fallbackDrawerSection
        ? replaceFromSection(fallbackDrawerSection, "#CartDrawer-Body", "#CartDrawer-Body")
        : false;
    }

    if (sections?.["cart-counter"]) {
      replaceFromSection(sections["cart-counter"], "#cart-counter", "#shopify-section-cart-counter");
    }

    let cartState = await getCartState().catch(() => null);
    const cleanedCartState = await removeLoneGiftBox(cartState);
    if (cleanedCartState !== cartState) {
      cartState = cleanedCartState;
      if (cartState?.sections?.["cart-drawer"]) {
        drawerUpdated =
          replaceFromSection(cartState.sections["cart-drawer"], "#CartDrawer-Body", "#CartDrawer-Body") ||
          drawerUpdated;
      }
      if (cartState?.sections?.["cart-counter"]) {
        replaceFromSection(cartState.sections["cart-counter"], "#cart-counter", "#shopify-section-cart-counter");
      }
    }

    cartState = syncCartCounters(cartState, drawerUpdated);

    if (typeof updateCartCounters === "function") updateCartCounters(cartState);
    if (typeof updateFreeShipping === "function") updateFreeShipping(cartState);

    cartDrawer?.classList.toggle("is-empty", Number(cartState?.item_count) === 0);
    if (typeof cartDrawer?.open === "function") {
      cartDrawer.open();
    } else if (cartDrawer) {
      cartDrawer.classList.add("is-visible");
      document.body.style.overflow = "hidden";
    }

    return cartState;
  };

  const setCartQuantityLoading = (quantityInput, loading) => {
    const cartDrawerItems = quantityInput.closest("cart-drawer-items");
    const quantity = quantityInput.closest("quantity-input");

    cartDrawerItems?.classList.toggle("is-loading", loading);
    quantityInput.dataset.hallstattUpdating = String(loading);
    quantityInput.toggleAttribute("readonly", loading);

    quantity?.querySelectorAll(".quantity__button").forEach(button => {
      button.toggleAttribute("disabled", loading);
      button.setAttribute("aria-disabled", String(loading));
    });
  };

  const showCartQuantityError = (quantityInput, message) => {
    const lineError = quantityInput.closest(".cart-item")?.querySelector("[data-line-item-error]");
    if (lineError) {
      lineError.textContent = message || "";
    }
  };

  const getCartQuantityValue = (quantityInput, button) => {
    const currentQuantity = Number(quantityInput.value) || 0;
    const step = quantityInput.step && quantityInput.step !== "any" ? Number(quantityInput.step) || 1 : 1;
    const min = quantityInput.min === "" ? 0 : Number(quantityInput.min);
    const max = quantityInput.max === "" ? Infinity : Number(quantityInput.max);
    const boundedMin = Number.isFinite(min) ? min : 0;
    const boundedMax = Number.isFinite(max) ? max : Infinity;

    return button.name === "increment"
      ? Math.min(currentQuantity + step, boundedMax)
      : Math.max(currentQuantity - step, boundedMin);
  };

  document.addEventListener("click", async event => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(".quantity__button");
    if (!button || !button.closest("cart-drawer")) return;
    if (button.name !== "increment" && button.name !== "decrement") return;

    const quantityInput = button.closest("quantity-input")?.querySelector('[name="updates[]"]');
    if (!quantityInput) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (quantityInput.dataset.hallstattUpdating === "true") return;

    const cartDrawer = button.closest("cart-drawer");
    const previousQuantity = Number(quantityInput.value) || 0;
    const nextQuantity = getCartQuantityValue(quantityInput, button);

    if (nextQuantity === previousQuantity) return;

    const line = Number(quantityInput.dataset.index);
    const basePayload = {
      quantity: nextQuantity,
      sections: getCartSectionNames(),
      sections_url: getCartUrl()
    };

    quantityInput.value = String(nextQuantity);
    setCartQuantityLoading(quantityInput, true);
    showCartQuantityError(quantityInput, "");

    try {
      let changeResponse = null;

      if (quantityInput.dataset.key) {
        changeResponse = await changeCartLine({
          ...basePayload,
          id: quantityInput.dataset.key
        });
      }

      if ((!changeResponse || changeResponse.errors) && Number.isFinite(line) && line > 0) {
        changeResponse = await changeCartLine({
          ...basePayload,
          line
        });
      }

      if (!changeResponse) {
        quantityInput.value = String(previousQuantity);
        showCartQuantityError(quantityInput, window.cartStrings?.error);
        return;
      }

      if (changeResponse.errors) {
        quantityInput.value = String(previousQuantity);
        showCartQuantityError(quantityInput, changeResponse.errors);
        return;
      }

      changeResponse = await removeLoneGiftBox(changeResponse);
      const cartState = await renderCart(cartDrawer, changeResponse?.sections);

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-drawer",
          cartData: cartState || changeResponse
        });
      }
    } catch (error) {
      quantityInput.value = String(previousQuantity);
      showCartQuantityError(quantityInput, error?.message || window.cartStrings?.error);
      console.error("Cart quantity could not be updated:", error);
    } finally {
      setCartQuantityLoading(quantityInput, false);
    }
  }, true);

  document.addEventListener("click", async event => {
    const removeButton = event.target.closest("cart-drawer cart-remove-button");
    if (!removeButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (removeButton.dataset.hallstattRemoving === "true") return;

    const cartDrawer = removeButton.closest("cart-drawer");
    const line = Number(removeButton.dataset.index);
    const basePayload = {
      quantity: 0,
      sections: getCartSectionNames(),
      sections_url: getCartUrl()
    };

    setCartDrawerLoading(removeButton, true);
    showCartLineError(removeButton, "");

    try {
      let changeResponse = null;

      if (removeButton.dataset.key) {
        changeResponse = await changeCartLine({
          ...basePayload,
          id: removeButton.dataset.key
        });
      }

      if ((!changeResponse || changeResponse.errors) && Number.isFinite(line) && line > 0) {
        changeResponse = await changeCartLine({
          ...basePayload,
          line
        });
      }

      if (!changeResponse) {
        showCartLineError(removeButton, window.cartStrings?.error);
        return;
      }

      if (changeResponse.errors) {
        showCartLineError(removeButton, changeResponse.errors);
        return;
      }

      changeResponse = await removeLoneGiftBox(changeResponse);
      const cartState = await renderCart(cartDrawer, changeResponse?.sections);

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-drawer",
          cartData: cartState || changeResponse
        });
      }
    } catch (error) {
      showCartLineError(removeButton, error?.message || window.cartStrings?.error);
      console.error("Cart item could not be removed:", error);
    } finally {
      setCartDrawerLoading(removeButton, false);
    }
  }, true);

  document.addEventListener("submit", async event => {
    const form = event.target.closest(selectors.productForm);
    if (!form) return;

    const productForm = getProductFormElement(form);
    if (!productForm || productForm.dataset.hallstattSubmitting === "true") {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    syncVariantSelection(productForm);

    if (!validateProductForm(form)) {
      showProductFormError(productForm, "Please select an available variant.");
      return;
    }

    const formData = buildProductFormData(form, productForm);
    if (!formData) {
      showProductFormError(productForm, window.cartStrings?.error || "Please select a purchase option.");
      return;
    }

    const addToCartRequest = buildAddToCartRequest(formData, productForm);
    if (!addToCartRequest) {
      showProductFormError(productForm, window.cartStrings?.error || "Please select an available variant.");
      return;
    }

    const buttons = getSubmitButtons(productForm, form);
    const cartDrawer = document.querySelector("cart-drawer");
    productForm.dataset.hallstattSubmitting = "true";
    showProductFormError(productForm, false);
    setProductFormLoading(buttons, true);
    cartDrawer?.querySelector(".cart-drawer-items")?.classList.add("is-adding");

    try {
      const addResponse = await fetchJson(getCartAjaxUrl(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || "/"}cart/add`), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
          ...addToCartRequest.headers
        },
        body: addToCartRequest.body
      }, 15000);

      const cartState = await renderCart(cartDrawer, addResponse.sections);

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: addToCartRequest.productVariantId,
          cartData: cartState || addResponse
        });
      }
    } catch (error) {
      showProductFormError(
        productForm,
        error?.name === "AbortError"
          ? "We couldn't add this item right now. Please try again."
          : error?.message || window.cartStrings?.error || "We couldn't add this item right now. Please try again."
      );
    } finally {
      productForm.dataset.hallstattSubmitting = "false";
      setProductFormLoading(buttons, false);
      cartDrawer?.querySelector(".cart-drawer-items")?.classList.remove("is-loading", "is-adding");
    }
  }, true);
})();
